import CrowdstrikeTable from './CrowdstrikeTable';
export default CrowdstrikeTable;
